import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';

import * as confirmationActions from '../actions/confirmation.action';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { BookingService } from '../../booking/services/booking.service';
import { Router } from '@angular/router';

@Injectable()
export class ConfirmationEffect {
  constructor(
    private actions$: Actions,
    private db: AngularFirestore,
    private bookingService: BookingService,
    private firebaseAuth: AngularFireAuth,
    private router: Router
  ) {}

  @Effect()
  viewConferenceConfirmation$ = this.actions$
    .ofType(confirmationActions.VIEW_CONFERENCE_CONFIRMATION)
    .pipe(
      switchMap((action: confirmationActions.ViewConferenceConfirmation) => {
        const bookingId = action.payload;
        return this.bookingService.getBooking(bookingId);
      }),
      map(
        booking =>
          new confirmationActions.ViewConferenceConfirmationSuccess(booking)
      ),
      tap(() => this.router.navigate(['/confirmations/conference'])),
      catchError(error =>
        of(new confirmationActions.ViewConferenceConfirmationFail(error))
      )
    );

  @Effect()
  viewAccommodationConfirmation$ = this.actions$
    .ofType(confirmationActions.VIEW_ACCOMMODATION_CONFIRMATION)
    .pipe(
      switchMap((action: confirmationActions.ViewAccommodationConfirmation) => {
        const bookingId = action.payload;
        return this.bookingService.getBooking(bookingId);
      }),
      map(
        booking =>
          new confirmationActions.ViewAccommodationConfirmationSuccess(booking)
      ),
      tap(() => this.router.navigate(['/confirmations/accommodation'])),
      catchError(error =>
        of(new confirmationActions.ViewAccommodationConfirmationFail(error))
      )
    );
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/effects/confirmation.effect.ts